module.exports = __webpack_public_path__ + "img/sun.b0f6144b.svg";